<mat-card class="event-card" appearance="outlined">
  <mat-card-header class="event-card-header">
    <figure class="event-photo-container">
      <img
        mat-card-image
        [src]="eventPhotoUrl"
        alt="Event Photo"
        class="event-photo"
      />
      @if (event.eventStatus === eventStatus.CANCELLED) {
        <figcaption class="cancelled-ribbon">CANCELLED</figcaption>
      }
    </figure>
    <mat-card-title class="event-name"
      >{{ event.eventName }}
      {{ event.startDate | date: "yyyy" }}</mat-card-title
    >
  </mat-card-header>
  <mat-divider class="divider"></mat-divider>
  <mat-card-content class="event-content">
    <section class="event-details">
      <p class="event-date">
        @if (event.startDate) {
          <span> {{ event.startDate | date: "HH:mm dd MMMM yyyy" }}</span>
        }
        @if (event.endDate) {
          <span> - {{ event.endDate | date: "HH:mm dd MMMM yyyy" }}</span>
        }
      </p>
      @if (isOverviewer) {
        <section class="Rsvp-numbers">
          <p>
            <span> {{ event.RsvpNumbers?.totalInvites }}</span> total invites
          </p>
          <p>
            <span> {{ event.RsvpNumbers?.confirmedRsvps }}</span> confirmed
          </p>
          <p>
            <span> {{ event.RsvpNumbers?.declinedRsvps }}</span> declined
          </p>
          <p>
            <span> {{ event.RsvpNumbers?.outstandingRsvps }}</span> outstanding
          </p>
        </section>
      }
      @if (isStudent) {
        <section class="rsvp-response">
          <p>
            RSVP: <span>{{ event.rsvp }}</span>
          </p>
        </section>
      }
    </section>
    <section class="button-container">
      <button
        mat-flat-button
        class="view-button"
        [color]="showRsvpButton(event) ? 'accent' : 'primary'"
        (click)="navigateToEventDetailsPage(event.eventGuid)"
      >
        {{
          event.eventStatus?.toLowerCase() === status.DRAFT
            ? buttonAction.CONTINUE_EVENT_CREATION
            : buttonAction.VIEW_EVENT_DETAILS
        }}
      </button>
      @if (showRsvpButton(event)) {
        <button
          mat-flat-button
          color="primary"
          class="view-button"
          (click)="openRsvpDialog(event)"
        >
          {{ buttonAction.RSVP }}
        </button>
      }
    </section>
  </mat-card-content>
</mat-card>
